module.exports = __webpack_public_path__ + "img/Form_active.4e58191b.svg";